import { Exclude, Expose, Transform } from 'class-transformer';
import { Equals, Length, MaxLength } from 'class-validator';

import { isNil } from 'lodash-es';

import { BaseModel } from '@core/data-access';

import { FlattenObject } from '../util';

export enum MyInfoAddressType {
  SG = 'SG',
  UNFORMATTED = 'UNFORMATTED',
}

@Exclude()
export class MyInfoAddressSG extends BaseModel {
  @Expose()
  @Equals(MyInfoAddressType.SG)
  type!: MyInfoAddressType.SG;

  @Expose()
  @FlattenObject('value')
  @MaxLength(10)
  block!: string;

  @Expose()
  @FlattenObject('value')
  @MaxLength(66)
  building!: string;

  @Expose()
  @FlattenObject('value')
  @MaxLength(3)
  floor!: string;

  @Expose()
  @FlattenObject('value')
  @MaxLength(5)
  unit!: string;

  @Expose()
  @FlattenObject('value')
  @MaxLength(66)
  street!: string;

  @Expose()
  @FlattenObject('value')
  @Length(6, 6)
  postal!: string;

  @Expose()
  @FlattenObject('value')
  @FlattenObject('desc')
  @Transform(({ value }) => (value === 'SG' ? 'SINGAPORE' : value))
  @Equals('SINGAPORE')
  country!: 'SINGAPORE';

  @Expose()
  get address(): string {
    const line1 = `${this.block ?? ''} ${this.street ?? ''}`.trim();
    const line2 = `${this.floor ? '#' + this.floor : ''}${this.unit ? '-' + this.unit : ''} ${this.building}`.trim();
    const line3 = `${this.country ?? ''} ${this.postal}`.trim();
    return [line1, line2, line3].filter(x => !isNil(x) && x !== '').join(', ');
  }
}

@Exclude()
export class MyInfoAddressNonSG extends BaseModel {
  @Expose()
  @Equals(MyInfoAddressType.UNFORMATTED)
  type!: MyInfoAddressType.UNFORMATTED;

  @Expose()
  @FlattenObject('value')
  @MaxLength(66)
  line1!: string;

  @Expose()
  @FlattenObject('value')
  @MaxLength(66)
  line2!: string;

  @Expose()
  get address(): string {
    return [this.line1, this.line2].filter(x => !isNil(x) && x !== '').join(', ');
  }
}
